// src/utils/paymentSemantics.js — Pass 47C §7: payment UNKNOWN ≠ UNPAID.
// The old 25/26 importer hardcoded paymentStatus='unpaid' on 1,225 historical rows —
// that is NOT positive evidence of collectable debt. Only an EXPLICIT not-paid state
// counts as unpaid. Missing / legacy-'unpaid' / inquiry → not_recorded.
export const PAYMENT = { PAID: 'paid', DEPOSIT: 'deposit_paid', NOT_PAID: 'not_paid', INQUIRY: 'inquiry', NOT_RECORDED: 'not_recorded' };

export function normalizePaymentState(raw) {
  const t = String(raw || '').toLowerCase().trim();
  if (!t) return PAYMENT.NOT_RECORDED;
  if (/fully.?paid|^paid$|paid in full/.test(t)) return PAYMENT.PAID;
  if (/deposit/.test(t)) return PAYMENT.DEPOSIT;
  if (/confirmed.?not.?paid|not.?paid|awaiting payment|outstanding|payment due|balance due/.test(t)) return PAYMENT.NOT_PAID;
  if (/reservation|inquiry|enquiry|pending|request/.test(t)) return PAYMENT.INQUIRY;
  // Legacy hardcoded default from the old importer — treat as NOT recorded, not debt.
  if (t === 'unpaid') return PAYMENT.NOT_RECORDED;
  return PAYMENT.NOT_RECORDED;
}

const rawOf = (b) => b.paymentState ?? b.paymentStatus;

// Positive evidence of an actionable unpaid/payment-due state. Missing/legacy/inquiry → false.
export function isPositivelyUnpaid(booking = {}) {
  return normalizePaymentState(rawOf(booking)) === PAYMENT.NOT_PAID && booking.status === 'confirmed';
}
export function isPaymentRecorded(booking = {}) {
  return normalizePaymentState(rawOf(booking)) !== PAYMENT.NOT_RECORDED;
}
export const paymentLabel = { paid: 'Fully paid', deposit_paid: 'Deposit paid', not_paid: 'Not paid', inquiry: 'Reservation / inquiry', not_recorded: 'Payment not recorded' };
